import { useSyncExternalStore } from 'react';

// Tiny global store for the user's current in-app location, as an ordered list
// of labels (e.g. ['Projects', 'Smith Residence', 'Rooms', 'Kitchen', 'Layout']).
// Views push their location as the user navigates; the bug-report dialog reads
// it so a report records exactly where the user was, not just the top module.
let current = [];
const listeners = new Set();

export function setBreadcrumb(crumbs) {
  const next = Array.isArray(crumbs)
    ? crumbs.filter(c => c != null && String(c).trim() !== '').map(c => String(c).trim())
    : [];
  // Skip no-op updates so useSyncExternalStore stays stable.
  if (next.length === current.length && next.every((c, i) => c === current[i])) return;
  current = next;
  listeners.forEach(l => { try { l(current); } catch (e) { /* ignore */ } });
}

export function getBreadcrumb() {
  return current;
}

export function getBreadcrumbString(sep = ' → ') {
  return current.join(sep);
}

function subscribe(fn) {
  listeners.add(fn);
  return () => listeners.delete(fn);
}

// React hook — returns the live breadcrumb array.
export function useBreadcrumb() {
  return useSyncExternalStore(subscribe, getBreadcrumb, getBreadcrumb);
}

// Prettify an unknown tab/module id (e.g. "project_tracker" -> "Project Tracker").
export function prettyLabel(id) {
  if (!id) return '';
  return String(id)
    .replace(/^__/, '')
    .replace(/[_-]+/g, ' ')
    .replace(/\b\w/g, c => c.toUpperCase());
}
